export const startsAndEndsWithAlphaNumeric = (string) =>
  /^[a-z0-9]+$/i.test(string.charAt(0)) && /^[a-z0-9]+$/i.test(string.charAt(string.length - 1));

// uppercase and lowercase letters, spaces, special characters
export const containsValidUsernameCharacters = (string) =>
  !/^[a-zA-Z0-9]+(([',. -][a-zA-Z0-9])?[a-zA-Z0-9]*)*$/.test(string);
